import { useAppSelector } from "@/lib/redux/hooks";
import LinkComponent from "next/link";
import { SVGLogo as SVGLogoComponent } from "@/lib/svg";
import { Anchor } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Link = LinkComponent as any;
const SVGLogo = SVGLogoComponent as any;

const Logo = () => {
  const desktopMenuOpen = useAppSelector((state) => state.desktopMenu.isOpen);
  return (
    <Link href={`/`}>
      <Anchor $desktopMenuOpen={desktopMenuOpen}>
        <SVGLogo />
      </Anchor>
    </Link>
  );
};

export default Logo;
